import { MenuItem, Position } from "@blueprintjs/core"
import { Suggest } from "@blueprintjs/select"
import React from "react"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import { usePeopleList } from "graphql/distribution-center/distribution-center.hooks"

const SupervisorSuggest = ({ value, path, onChange, disabled = undefined }) => {
  const { data } = usePeopleList("", "Loading Supervisor")
  return (
    <CustomFormGroup disabled={disabled} label="Supervisor">
      <Suggest
        fill
        selectedItem={value}
        disabled={disabled}
        onItemSelect={e => onChange(path, e)}
        popoverProps={{ minimal: true, position: Position.BOTTOM_LEFT }}
        items={data?.usersByGroup ?? []}
        inputValueRenderer={item => `${item?.firstName} ${item?.lastName}`}
        itemRenderer={(item, { handleClick, modifiers }) => {
          return (
            <MenuItem
              disabled={disabled}
              icon="user"
              key={item?.id}
              text={`${item?.firstName} ${item?.lastName}`}
              label={item?.number}
              onClick={handleClick}
              active={modifiers.active}
            />
          )
        }}
      />
    </CustomFormGroup>
  )
}

export default SupervisorSuggest
